import isArray from '../type-check/is-array.js';
import isObject from '../type-check/is-object.js';
import isString from '../type-check/is-string.js';

/**
 * @func hasLength
 * @param {object | string | Array} value - check the length of this value.
 * @return {boolean}
 * @desc Determines if an object has keys (also accepts arrays and strings)
 * ```js
 * hasLength({ id: 1 });
 * hasLength([1]);
 * hasLength('one');
 * // returns true
 * ```
 * @memberof module:Object
 * @instance
 */
function hasLength(value) {
    if (isArray(value) || isString(value))
        return !!value.length;
    if (isObject(value))
        return !!Object.keys(value).length;
    return false;
}

export { hasLength as default };
